var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/DualHookShowcaseUpsell/DualHookShowcaseUpsellWrapper.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { useYieldCallback } from '@zillow/yield-callback';
import { appendQueryParameter } from '../../../../../utils/stringUtils';
import DualHookShowcaseUpsellTemplate from './DualHookShowcaseUpsellTemplate';
import { formNewLaneEventPayload } from '../../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../../eventing/clickStreamEventSchema';
import { useOnsiteMessagingClickstreamImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingClickstreamImpressionEvent';
import { useOnsiteMessagingClickstreamIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingClickstreamIntentToShowEvent';
import { ClickstreamEvent } from '../../../../../eventing/ClickstreamEvent';
export var DualHookShowcaseUpsell = function DualHookShowcaseUpsell(_ref) {
  var upsellTitleText = _ref.upsellTitleText,
      upsellSubtitleText = _ref.upsellSubtitleText,
      actionText = _ref.actionText,
      firstHookTitle = _ref.firstHookTitle,
      firstHookMarkdownText = _ref.firstHookMarkdownText,
      firstHookPopoverTitleText = _ref.firstHookPopoverTitleText,
      firstHookPopoverBodyText = _ref.firstHookPopoverBodyText,
      firstHookPopoverButtonText = _ref.firstHookPopoverButtonText,
      firstHookPopoverButtonRedirectUrl = _ref.firstHookPopoverButtonRedirectUrl,
      firstHookValueZestimatePercent = _ref.firstHookValueZestimatePercent,
      secondHookTitle = _ref.secondHookTitle,
      secondHookMarkdownText = _ref.secondHookMarkdownText,
      secondHookPopoverTitleText = _ref.secondHookPopoverTitleText,
      secondHookPopoverBodyText = _ref.secondHookPopoverBodyText,
      secondHookPopoverButtonText = _ref.secondHookPopoverButtonText,
      secondHookPopoverButtonRedirectUrl = _ref.secondHookPopoverButtonRedirectUrl,
      secondHookValue = _ref.secondHookValue,
      staticFirstHook = _ref.staticFirstHook,
      standingOfferPrice = _ref.standingOfferPrice,
      trackingParameter = _ref.trackingParameter,
      zpid = _ref.zpid,
      actionLink = _ref.actionLink,
      additionalProps = _ref.additionalProps,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData;
  var signalForTriggerTracking = additionalProps.signalForTriggerTracking;
  var ref = useOnsiteMessagingClickstreamImpressionEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingClickstreamIntentToShowEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    signalForTriggerTracking: signalForTriggerTracking
  });
  var questionnaireLink = appendQueryParameter(actionLink, trackingParameter, zpid);
  var onClickUpsellButton = useYieldCallback(function () {
    ClickstreamEvent(formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData));

    if (actionLink) {
      window.open(questionnaireLink, '_blank');
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(DualHookShowcaseUpsellTemplate, {
    upsellTitleText: upsellTitleText,
    upsellSubtitleText: upsellSubtitleText,
    firstHookTitle: firstHookTitle,
    firstHookMarkdownText: firstHookMarkdownText,
    firstHookPopoverTitleText: firstHookPopoverTitleText,
    firstHookPopoverBodyText: firstHookPopoverBodyText,
    firstHookPopoverButtonText: firstHookPopoverButtonText,
    firstHookPopoverButtonRedirectUrl: firstHookPopoverButtonRedirectUrl,
    firstHookValueZestimatePercent: firstHookValueZestimatePercent,
    secondHookTitle: secondHookTitle,
    secondHookMarkdownText: secondHookMarkdownText,
    secondHookPopoverTitleText: secondHookPopoverTitleText,
    secondHookPopoverBodyText: secondHookPopoverBodyText,
    secondHookPopoverButtonText: secondHookPopoverButtonText,
    secondHookPopoverButtonRedirectUrl: secondHookPopoverButtonRedirectUrl,
    secondHookValue: secondHookValue,
    actionText: actionText,
    staticFirstHook: staticFirstHook,
    standingOfferPrice: standingOfferPrice,
    onClickUpsellButton: onClickUpsellButton,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 13
    }
  }));
};
DualHookShowcaseUpsell.propTypes = process.env.NODE_ENV !== "production" ? {
  staticFirstHook: PropTypes.string,
  standingOfferPrice: PropTypes.string,
  firstHookTitle: PropTypes.string,
  firstHookMarkdownText: PropTypes.string,
  firstHookPopoverTitleText: PropTypes.string,
  firstHookPopoverBodyText: PropTypes.string,
  firstHookPopoverButtonText: PropTypes.string,
  firstHookPopoverButtonRedirectUrl: PropTypes.string,
  firstHookValueZestimatePercent: PropTypes.string,
  secondHookTitle: PropTypes.string,
  secondHookMarkdownText: PropTypes.string,
  secondHookPopoverTitleText: PropTypes.string,
  secondHookPopoverBodyText: PropTypes.string,
  secondHookPopoverButtonText: PropTypes.string,
  secondHookPopoverButtonRedirectUrl: PropTypes.string,
  secondHookValue: PropTypes.string,
  trackingParameter: PropTypes.string,
  zpid: PropTypes.string,
  actionLink: PropTypes.string,
  upsellTitleText: PropTypes.string,
  upsellSubtitleText: PropTypes.string,
  actionText: PropTypes.string,
  additionalProps: PropTypes.shape({
    signalForTriggerTracking: PropTypes.bool
  }),
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object
} : {};
DualHookShowcaseUpsell.defaultProps = {
  actionLink: '',
  upsellTitleText: '',
  firstHookTitle: '',
  firstHookMarkdownText: '',
  firstHookPopoverTitleText: '',
  firstHookPopoverBodyText: '',
  firstHookPopoverButtonText: '',
  firstHookPopoverButtonRedirectUrl: '',
  firstHookValueZestimatePercent: '',
  secondHookTitle: '',
  secondHookMarkdownText: '',
  secondHookPopoverTitleText: '',
  secondHookPopoverBodyText: '',
  secondHookPopoverButtonText: '',
  secondHookPopoverButtonRedirectUrl: '',
  secondHookValue: '',
  upsellSubtitleText: '',
  actionText: '',
  trackingParameter: '',
  zpid: null,
  additionalProps: {},
  newLaneEventData: {},
  additionalClickStreamData: {}
};